import React, { useState, useEffect, useCallback } from 'react';
import DoctorHours from './DoctorHours';
import clinicbookingService from '../../../../../services/clinicbooking.service';
import CustomHours from './CustomHours';
import AddEditDoctorInfo from './AddEditDoctorInfo';
import Loading from '../../../../common/Loading';
import { toast } from 'react-toastify';

function DocInfo({ doc, onBack }) {
    const [doctor, setDoctor] = useState(null);
    const [editInfo, setEditInfo] = useState(false);
    const [apptEdit, setApptEdit] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [docApptType, setDocApptType] = useState([]);
    const [allApptType, setAllApptType] = useState([]);
    const [isAddAppt, setIsAddAppt] = useState(false);

    const getApptType = useCallback(() => {
        return clinicbookingService
            .getApptTypeToDoctor(doc.clinicId, doc.id, doc.userId)
            .then((res) => setDocApptType(res.data || []))
            .catch((err) => console.log(err));
    }, [doc.clinicId, doc.id, doc.userId]);

    const getAllApptType = useCallback(() => {
        return clinicbookingService
            .getAllApptType(doc.clinicId)
            .then((res) => setAllApptType(res.data || []))
            .catch((err) => console.log(err));
    }, [doc.clinicId]);

    const getDoctorById = useCallback(() => {
        return clinicbookingService
            .getDoctorById(doc.clinicId, doc.id)
            .then((res) => setDoctor(res.data))
            .catch((err) => console.log(err));
    }, [doc.clinicId, doc.id]);

    useEffect(() => {
        setIsLoading(true);
        Promise.all([getDoctorById(), getAllApptType(), getApptType()]).finally(() => setIsLoading(false));
    }, [getDoctorById, getAllApptType, getApptType]);

    const toogleEdit = () => {
        setEditInfo((prev) => !prev);
        if (!editInfo) {
            setApptEdit(false);
            setIsAddAppt(false);
        }
    };

    const updateDoc = (updated) => setDoctor(updated);

    const toogleApptEdit = () => {
        setApptEdit((prev) => !prev);
        setIsAddAppt(false);
        if (!apptEdit) {
            setEditInfo(false);
        }
    };

    const handleDeleteAppt = (appt) => {
        clinicbookingService
            .deleteApptTypeToDoctor(appt.clinicId, appt.doctorId, appt.userId, [appt.appointmentTypeId])
            .then(() => getApptType())
            .catch((err) => {
                console.log(err);
                toast.error('Failed to remove appointment type');
            });
    };

    const handleAddAppt = (appt) => {
        clinicbookingService
            .addUpdateApptTypeToDoctor(appt.clinicId, doc.id, doc.userId, [appt.id])
            .then(() => getApptType())
            .catch((err) => {
                console.log(err);
                toast.error('Failed to add appointment type');
            });
    };

    const inApptList = (id) => docApptType.some((appt) => appt.appointmentTypeId === id);

    const availableApptTypes = allApptType.filter((appt) => !inApptList(appt.id));

    if (isLoading) {
        return <Loading />;
    }

    if (!doctor) {
        return (
            <div className="clinic-booking-empty">
                <i className="bi bi-exclamation-circle"></i>
                Unable to load doctor details.
                <div className="mt-3">
                    <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onBack}>
                        <i className="bi bi-arrow-left me-1"></i>
                        Back to Doctors List
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="clinic-booking-doctor-detail">
            <div className="clinic-booking-doctor-detail__toolbar">
                <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onBack}>
                    <i className="bi bi-arrow-left me-1"></i>
                    Back to Doctors List
                </button>
                {!editInfo && (
                    <div className="d-flex flex-wrap gap-2">
                        <button
                            type="button"
                            className={`btn btn-sm ${apptEdit ? 'btn-outline-danger' : 'btn-outline-primary'}`}
                            onClick={toogleApptEdit}
                        >
                            <i className={`bi ${apptEdit ? 'bi-x-lg' : 'bi-calendar2-plus'} me-1`}></i>
                            {apptEdit ? 'Done Types' : 'Edit Appt Types'}
                        </button>
                        <button type="button" className="btn btn-outline-primary btn-sm" onClick={toogleEdit}>
                            <i className="bi bi-pencil me-1"></i>
                            Edit Info
                        </button>
                    </div>
                )}
            </div>

            {editInfo ? (
                <AddEditDoctorInfo doctor={doctor} updateDoc={updateDoc} toogleEdit={toogleEdit} />
            ) : (
                <>
                    <div className="clinic-booking-doctor-detail__grid">
                        <div className="notifications-panel clinic-booking-doctor-detail__profile">
                            <div className="notifications-panel__header">
                                <i className="bi bi-person-badge"></i>
                                Profile
                            </div>
                            <div className="notifications-panel__body">
                                <div className="clinic-booking-doctor-profile">
                                    {doctor.photoUrl ? (
                                        <img
                                            src={doctor.photoUrl}
                                            className="clinic-booking-doctor-profile__photo"
                                            alt={doctor.name}
                                            onError={(e) => {
                                                e.currentTarget.style.display = 'none';
                                                const fallback = e.currentTarget.nextElementSibling;
                                                if (fallback) fallback.style.display = 'flex';
                                            }}
                                        />
                                    ) : null}
                                    <div
                                        className="clinic-booking-doctor-profile__photo clinic-booking-doctor-profile__photo--placeholder"
                                        style={{ display: doctor.photoUrl ? 'none' : 'flex' }}
                                    >
                                        {(doctor.name || '?').charAt(0)}
                                    </div>

                                    <div className="clinic-booking-doctor-profile__name">{doctor.name}</div>
                                    <span
                                        className={`clinic-booking-status-badge ${
                                            doctor.isActive
                                                ? 'clinic-booking-status-badge--active'
                                                : 'clinic-booking-status-badge--inactive'
                                        }`}
                                    >
                                        <i className={`bi ${doctor.isActive ? 'bi-check-circle' : 'bi-x-circle'}`}></i>
                                        {doctor.isActive ? 'Active' : 'Inactive'}
                                    </span>

                                    <div className="clinic-booking-doctor-profile__meta">
                                        <div>
                                            <span className="notifications-info-label">Created</span>
                                            <span className="notifications-info-value">{doctor.createdAt || '—'}</span>
                                        </div>
                                        <div>
                                            <span className="notifications-info-label">Updated</span>
                                            <span className="notifications-info-value">{doctor.modifiedAt || '—'}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="notifications-panel clinic-booking-doctor-detail__details">
                            <div className="notifications-panel__header">
                                <i className="bi bi-info-circle"></i>
                                Details &amp; Appointment Types
                            </div>
                            <div className="notifications-panel__body">
                                <div className="clinic-booking-doctor-section">
                                    <div className="clinic-booking-doctor-section__title">Biography</div>
                                    <div className="clinic-booking-doctor-bio">
                                        {doctor.bio ? (
                                            doctor.bio
                                        ) : (
                                            <span className="text-muted fst-italic">No biography available</span>
                                        )}
                                    </div>
                                </div>

                                <div className="clinic-booking-doctor-section clinic-booking-doctor-section--last">
                                    <div className="clinic-booking-doctor-section__title d-flex align-items-center justify-content-between gap-2">
                                        <span>Appointment Types</span>
                                        {!apptEdit && docApptType.length > 0 && (
                                            <span className="clinic-booking__count">({docApptType.length})</span>
                                        )}
                                    </div>

                                    {apptEdit ? (
                                        <div className="clinic-booking-appt-manage">
                                            <div className="clinic-booking-appt-manage__block">
                                                <div className="clinic-booking-appt-manage__label">Assigned</div>
                                                {docApptType.length === 0 ? (
                                                    <div className="alert alert-info py-2 mb-0 border-0">
                                                        <i className="bi bi-info-circle me-1"></i>
                                                        No appointment types assigned yet.
                                                    </div>
                                                ) : (
                                                    <div className="clinic-booking-appt-list">
                                                        {docApptType.map((docAppt) => (
                                                            <div key={docAppt.id} className="clinic-booking-appt-list__item">
                                                                <div>
                                                                    <div className="clinic-booking-name">{docAppt.apptType}</div>
                                                                    <div className="clinic-booking-meta">{docAppt.timeSlot} minutes</div>
                                                                </div>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-outline-danger btn-sm"
                                                                    onClick={() => handleDeleteAppt(docAppt)}
                                                                    title="Remove appointment type"
                                                                >
                                                                    <i className="bi bi-trash"></i>
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>

                                            {isAddAppt ? (
                                                <div className="clinic-booking-appt-manage__block">
                                                    <div className="clinic-booking-appt-manage__label">Available to add</div>
                                                    {availableApptTypes.length === 0 ? (
                                                        <div className="alert alert-warning py-2 mb-0 border-0">
                                                            <i className="bi bi-exclamation-triangle me-1"></i>
                                                            No additional appointment types available.
                                                        </div>
                                                    ) : (
                                                        <div className="clinic-booking-appt-list">
                                                            {availableApptTypes.map((appointment) => (
                                                                <div key={appointment.id} className="clinic-booking-appt-list__item">
                                                                    <div>
                                                                        <div className="clinic-booking-name">{appointment.apptType}</div>
                                                                        <div className="clinic-booking-meta">{appointment.timeSlot} minutes</div>
                                                                    </div>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-success btn-sm"
                                                                        onClick={() => handleAddAppt(appointment)}
                                                                        title="Add appointment type"
                                                                    >
                                                                        <i className="bi bi-plus-lg me-1"></i>
                                                                        Add
                                                                    </button>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                    <div className="mt-2">
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-secondary btn-sm"
                                                            onClick={() => setIsAddAppt(false)}
                                                        >
                                                            <i className="bi bi-arrow-left me-1"></i>
                                                            Back
                                                        </button>
                                                    </div>
                                                </div>
                                            ) : (
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-sm"
                                                    onClick={() => setIsAddAppt(true)}
                                                    disabled={availableApptTypes.length === 0}
                                                >
                                                    <i className="bi bi-plus-circle me-1"></i>
                                                    Add Appointment Type
                                                </button>
                                            )}
                                        </div>
                                    ) : docApptType.length > 0 ? (
                                        <div className="clinic-booking-appt-chips">
                                            {docApptType.map((type) => (
                                                <span key={type.id || type.appointmentTypeId} className="clinic-booking-duration-badge">
                                                    <i className="bi bi-clock"></i>
                                                    {type.apptType} ({type.timeSlot} mins)
                                                </span>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className="alert alert-info py-2 mb-0 border-0">
                                            <i className="bi bi-info-circle me-1"></i>
                                            No appointment types assigned yet.
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {!apptEdit && (
                        <div className="clinic-booking-doctor-detail__hours">
                            <div className="clinic-booking-hours-panel">
                                <DoctorHours id={doc.id} clinicid={doc.clinicId} />
                            </div>
                            <div className="clinic-booking-custom-hours-panel">
                                <CustomHours doctorid={doc.id} clinicid={doc.clinicId} userid={doc.userId} />
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}

export default DocInfo;
